import { render, staticRenderFns } from "./productTypeList.vue?vue&type=template&id=77f5a582&scoped=true&"
import script from "./productTypeList.vue?vue&type=script&lang=js&"
export * from "./productTypeList.vue?vue&type=script&lang=js&"
import style0 from "./productTypeList.vue?vue&type=style&index=0&id=77f5a582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f5a582",
  null
  
)

export default component.exports